import _extends from "@babel/runtime/helpers/extends";
// @ts-nocheck

import Print from "./cn-print";
import PddPrint from "./pdd-print";
import JdPrint from "./jd-print";
import BytePrint from "./byte-print";
import CloudPrint from "./cloud-print";
import KuaiShouPrint from "./kuaishou-print";
import VipPrint from "./vip-print";
import HuaWeiPrint from "./huawei-print";
import XhsPrint from "./xhs-print";
import { COMMENDCONFIG, MessageCenter, doLog, EventManager } from "./event";
import { CAINIAO, PDD, JD, BYTE, KUAISHOU, NAMEMAPINSTANCE, VIP, HUAWEI, XHS } from "./consts";
var CnCommonPrint = /*#__PURE__*/function () {
  function CnCommonPrint(opts) {
    if (opts === void 0) {
      opts = {};
    }
    this.url = '';
    this.config = {};
    this.addEventListen = void 0;
    this.doLog = void 0;
    this.printData = void 0;
    this.getPrintConfigNameList = void 0;
    // 是否启用wet打印
    this.isNeedWetPrint = true;
    // 是否启用云打印
    this.isNeedCloudPrint = false;
    // 是否启用拼多多打印
    this.isNeedPddPrint = false;
    // 是否启用京东打印
    this.isNeedJdPrint = false;
    // 是否启用抖音打印
    this.isNeedBytePrint = false;
    // 是否启用快手打印
    this.isNeedKuaiShouPrint = false;
    // 是否启用唯品会打印
    this.isNeedVipPrint = false;
    // 是否启用华为商城打印
    this.isNeedHuaWeiPrint = false;
    // 是否启用小红书打印
    this.isNeedXhsPrint = false;
    // wet监听
    this.unsubscribeWet = null;
    // pdd监听
    this.unsubscribePdd = null;
    // 京东监听
    this.unsubscribeJd = null;
    // 抖音监听
    this.unsubscribeByte = null;
    // 云监听
    this.unsubscribeCloud = null;
    // 快手
    this.unsubscribeKuaiShou = null;
    // 唯品会
    this.unsubscribeVip = null;
    // 华为商城
    this.unsubscribeHuaWei = null;
    // 小红书
    this.unsubscribeXhs = null;
    // pdd debuger url
    this.pddDebugerUrl = '';
    // jd debuger url
    this.jdDebugerUrl = '';
    // wet debuger url
    this.wetDebugerUrl = '';
    // cloud  debuger url
    this.cloudDebugerUrl = '';
    // byte debuger url
    this.byteDebugerUrl = '';
    // kuaishou debuger url
    this.kuaiShouDebugerUrl = '';
    // 唯品会 debugger url
    this.vipDebuggerUrl = '';
    // 华为商城 debugger url
    this.huaWeiDebuggerUrl = '';
    // 小红书 debugger url
    this.xhsDebuggerUrl = '';
    this.isWetReady = false;
    this.isPddReady = true;
    this.isJdReady = true;
    this.isByteReady = true;
    this.isCloudReady = true;
    this.isKuaiShouReady = true;
    this.isVipReady = true;
    this.isHuaWeiReady = true;
    this.isXhsReady = true;
    this.messageChannel = void 0;
    this.wetIsInit = true;
    this.handlerError = void 0;
    this.handlerClose = void 0;
    var _opts = opts,
      _opts$isNeedWetPrint = _opts.isNeedWetPrint,
      isNeedWetPrint = _opts$isNeedWetPrint === void 0 ? true : _opts$isNeedWetPrint,
      _opts$isNeedCloudPrin = _opts.isNeedCloudPrint,
      isNeedCloudPrint = _opts$isNeedCloudPrin === void 0 ? false : _opts$isNeedCloudPrin,
      _opts$isNeedPddPrint = _opts.isNeedPddPrint,
      isNeedPddPrint = _opts$isNeedPddPrint === void 0 ? false : _opts$isNeedPddPrint,
      _opts$isNeedJdPrint = _opts.isNeedJdPrint,
      isNeedJdPrint = _opts$isNeedJdPrint === void 0 ? false : _opts$isNeedJdPrint,
      _opts$isNeedBytePrint = _opts.isNeedBytePrint,
      isNeedBytePrint = _opts$isNeedBytePrint === void 0 ? false : _opts$isNeedBytePrint,
      _opts$isNeedKuaiShouP = _opts.isNeedKuaiShouPrint,
      isNeedKuaiShouPrint = _opts$isNeedKuaiShouP === void 0 ? false : _opts$isNeedKuaiShouP,
      _opts$isNeedVipPrint = _opts.isNeedVipPrint,
      isNeedVipPrint = _opts$isNeedVipPrint === void 0 ? false : _opts$isNeedVipPrint,
      _opts$isNeedHuaWeiPri = _opts.isNeedHuaWeiPrint,
      isNeedHuaWeiPrint = _opts$isNeedHuaWeiPri === void 0 ? false : _opts$isNeedHuaWeiPri,
      _opts$isNeedXhsPrint = _opts.isNeedXhsPrint,
      isNeedXhsPrint = _opts$isNeedXhsPrint === void 0 ? false : _opts$isNeedXhsPrint,
      _opts$messageChannel = _opts.messageChannel,
      messageChannel = _opts$messageChannel === void 0 ? function () {} : _opts$messageChannel,
      _opts$pddDebugerUrl = _opts.pddDebugerUrl,
      pddDebugerUrl = _opts$pddDebugerUrl === void 0 ? '' : _opts$pddDebugerUrl,
      _opts$wetDebugerUrl = _opts.wetDebugerUrl,
      wetDebugerUrl = _opts$wetDebugerUrl === void 0 ? '' : _opts$wetDebugerUrl,
      _opts$jdDebugerUrl = _opts.jdDebugerUrl,
      jdDebugerUrl = _opts$jdDebugerUrl === void 0 ? '' : _opts$jdDebugerUrl,
      _opts$byteDebugerUrl = _opts.byteDebugerUrl,
      byteDebugerUrl = _opts$byteDebugerUrl === void 0 ? '' : _opts$byteDebugerUrl,
      _opts$cloudDebugerUrl = _opts.cloudDebugerUrl,
      cloudDebugerUrl = _opts$cloudDebugerUrl === void 0 ? '' : _opts$cloudDebugerUrl,
      _opts$kuaiShouDebuger = _opts.kuaiShouDebugerUrl,
      kuaiShouDebugerUrl = _opts$kuaiShouDebuger === void 0 ? '' : _opts$kuaiShouDebuger,
      _opts$vipDebuggerUrl = _opts.vipDebuggerUrl,
      vipDebuggerUrl = _opts$vipDebuggerUrl === void 0 ? '' : _opts$vipDebuggerUrl,
      _opts$huaWeiDebuggerU = _opts.huaWeiDebuggerUrl,
      huaWeiDebuggerUrl = _opts$huaWeiDebuggerU === void 0 ? '' : _opts$huaWeiDebuggerU,
      _opts$xhsDebuggerUrl = _opts.xhsDebuggerUrl,
      xhsDebuggerUrl = _opts$xhsDebuggerUrl === void 0 ? '' : _opts$xhsDebuggerUrl;
    this.isNeedWetPrint = isNeedCloudPrint ? false : isNeedWetPrint; // 云打印启动的话WET就停用
    this.isNeedCloudPrint = isNeedCloudPrint;
    this.isNeedPddPrint = isNeedPddPrint;
    this.isNeedJdPrint = isNeedJdPrint;
    this.isNeedBytePrint = isNeedBytePrint;
    this.isNeedKuaiShouPrint = isNeedKuaiShouPrint;
    this.isNeedVipPrint = isNeedVipPrint;
    this.isNeedHuaWeiPrint = isNeedHuaWeiPrint;
    this.isNeedXhsPrint = isNeedXhsPrint;
    this.messageChannel = messageChannel;
    this.pddDebugerUrl = pddDebugerUrl;
    this.wetDebugerUrl = wetDebugerUrl;
    this.jdDebugerUrl = jdDebugerUrl;
    this.byteDebugerUrl = byteDebugerUrl;
    this.cloudDebugerUrl = cloudDebugerUrl;
    this.kuaiShouDebugerUrl = kuaiShouDebugerUrl;
    this.vipDebuggerUrl = vipDebuggerUrl;
    this.huaWeiDebuggerUrl = huaWeiDebuggerUrl;
    this.xhsDebuggerUrl = xhsDebuggerUrl;
    this.wetIsInit = true;
    this.init();
    EventManager.Instance.supposeCloud = isNeedCloudPrint;
  }
  var _proto = CnCommonPrint.prototype;
  _proto.init = function init() {
    var _this = this;
    Object.keys(NAMEMAPINSTANCE).forEach(function (key) {
      var _NAMEMAPINSTANCE$key = NAMEMAPINSTANCE[key],
        url = _NAMEMAPINSTANCE$key.url,
        need = _NAMEMAPINSTANCE$key.need,
        instance = _NAMEMAPINSTANCE$key.instance,
        ready = _NAMEMAPINSTANCE$key.ready,
        unListen = _NAMEMAPINSTANCE$key.unListen;
      var tmpUrl = _this[url] || '';
      var isNeed = _this[need];
      if (isNeed) {
        var _CnCommonPrint$instan, _CnCommonPrint$instan2;
        var opt = {};
        if (tmpUrl) {
          opt.url = tmpUrl;
        }
        if (CnCommonPrint[instance] && CnCommonPrint[instance] !== null) {
          CnCommonPrint[instance].isReady = true;
        } else if (key === CAINIAO) {
          CnCommonPrint[instance] = new Print(opt);
        } else if (key === 'CLOUD') {
          CnCommonPrint[instance] = new CloudPrint(opt);
        } else if (key === PDD) {
          CnCommonPrint[instance] = new PddPrint(opt);
        } else if (key === JD) {
          CnCommonPrint[instance] = new JdPrint(opt);
        } else if (key === BYTE) {
          CnCommonPrint[instance] = new BytePrint(opt);
        } else if (key === KUAISHOU) {
          CnCommonPrint[instance] = new KuaiShouPrint(opt);
        } else if (key === VIP) {
          CnCommonPrint[instance] = new VipPrint(opt);
        } else if (key === HUAWEI) {
          CnCommonPrint[instance] = new HuaWeiPrint(opt);
        } else if (key === XHS) {
          CnCommonPrint[instance] = new XhsPrint(opt);
        }
        _this[unListen] = CnCommonPrint === null || CnCommonPrint === void 0 ? void 0 : (_CnCommonPrint$instan = CnCommonPrint[instance]) === null || _CnCommonPrint$instan === void 0 ? void 0 : (_CnCommonPrint$instan2 = _CnCommonPrint$instan.subscribe) === null || _CnCommonPrint$instan2 === void 0 ? void 0 : _CnCommonPrint$instan2.call(_CnCommonPrint$instan, function (data) {
          var success = data.success,
            _data$error = data.error,
            error = _data$error === void 0 ? {} : _data$error;
          _this[ready] = success;
          var inst = CnCommonPrint[instance];
          if (key === CAINIAO && inst.isReady && _this.wetIsInit && success) {
            var _inst$input, _inst$input$next, _wetStringify, _ref;
            _this.wetIsInit = false;
            (_inst$input = inst.input) === null || _inst$input === void 0 ? void 0 : (_inst$input$next = _inst$input.next) === null || _inst$input$next === void 0 ? void 0 : _inst$input$next.call(_inst$input, inst && (inst === null || inst === void 0 ? void 0 : (_wetStringify = (_ref = inst).wetStringify) === null || _wetStringify === void 0 ? void 0 : _wetStringify.call(_ref, {
              bussinessType: inst.bussinessType,
              messageType: inst.initMessageType
            })));
            inst.isReady = false;
          }
          if (!success) {
            var message = {
              data: {
                cmd: 'connectError'
              },
              dataSource: key,
              error: error
            };
            MessageCenter.listen(message);
            // 因为大宝上报太频繁，暂时关闭连接异常的日志上报
            // try {
            // const logParams = {
            //   status: 'failed',
            //   process: 'FRONT_END',
            //   action: 'WebSocketDisconnect',
            //   request: message,
            // };
            // doLog(logParams);
            // } catch (e) {
            // do nothing
            // }
          }
          _this.messageChannel(data);
        });
      }
    });
    this._initMethods();
  }

  // 触发打印出错
  ;
  _proto.triggerNotifyPrintError = function triggerNotifyPrintError(dataSource, item) {
    if (item === void 0) {
      item = {};
    }
    var res = {};
    if (dataSource == CAINIAO) {
      var taskID;
      var printer;
      var traceId;
      var bizCode;
      if (EventManager.Instance.supposeCloud) {
        var _item = item,
          _item$task = _item.task,
          task = _item$task === void 0 ? {} : _item$task;
        taskID = task.taskID;
        printer = task.printer;
        traceId = item.traceId;
        bizCode = item.bizCode;
      } else {
        var _item$data, _item$data2;
        var _item2 = item,
          _item2$data = _item2.data,
          _data = _item2$data === void 0 ? {} : _item2$data;
        var _task = _data.task || {};
        taskID = _task.taskID;
        printer = _task.printer;
        traceId = (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.traceId;
        bizCode = (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.bizCode;
      }
      res = {
        dataSource: dataSource,
        data: _extends({
          cmd: 'notifyPrintError',
          errorMessage: 'WET连接异常，请检查是否有漏打情况，刷新浏览器并进行补打'
        }, item, {
          traceId: traceId,
          taskID: taskID,
          printer: printer,
          bizCode: bizCode
        })
      };
    } else {
      var _item3 = item,
        _item3$key = _item3.key,
        key = _item3$key === void 0 ? '' : _item3$key,
        _item3$parameters = _item3.parameters,
        parameters = _item3$parameters === void 0 ? {} : _item3$parameters,
        _item3$task = _item3.task,
        _task2 = _item3$task === void 0 ? {} : _item3$task;
      var _parameters$printName = parameters.printName,
        printName = _parameters$printName === void 0 ? '' : _parameters$printName;
      var _task2$taskID = _task2.taskID,
        _taskID = _task2$taskID === void 0 ? '' : _task2$taskID,
        _task2$printer = _task2.printer,
        _printer = _task2$printer === void 0 ? '' : _task2$printer;
      var tmpPrintName = dataSource.toLowerCase();
      res = _extends({
        dataSource: dataSource,
        errorMessage: tmpPrintName + "\u8FDE\u63A5\u5F02\u5E38\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u6709\u6F0F\u6253\u60C5\u51B5\uFF0C\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u8FDB\u884C\u8865\u6253",
        printStatus: [{
          msg: tmpPrintName + "\u8FDE\u63A5\u5F02\u5E38\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u6709\u6F0F\u6253\u60C5\u51B5\uFF0C\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u8FDB\u884C\u8865\u6253"
        }]
      }, item, {
        cmd: 'notifyPrintError',
        taskID: key || _taskID,
        printer: printName || _printer
      });
    }
    MessageCenter.listen(res);
  };
  _proto.checkConnect = function checkConnect(dataSource, data) {
    if (dataSource === PDD && CnCommonPrint.pddPrintInstance) {
      if (!this.isPddReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    if (dataSource === JD && CnCommonPrint.jdPrintInstance) {
      if (!this.isJdReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    if (dataSource === BYTE && CnCommonPrint.bytePrintInstance) {
      if (!this.isByteReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    if (dataSource === KUAISHOU && CnCommonPrint.kuaiShouPrintInstance) {
      if (!this.isKuaiShouReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    if (dataSource === VIP && CnCommonPrint.vipPrintInstance) {
      if (!this.isVipReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    if (dataSource === HUAWEI && CnCommonPrint.huaWeiPrintInstance) {
      if (!this.isHuaWeiReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    if (dataSource === CAINIAO) {
      if (CnCommonPrint.wetPrintInstance && !this.isWetReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
      if (CnCommonPrint.cloudPrintInstance && !this.isCloudReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    if (dataSource === XHS && CnCommonPrint.xhsPrintInstance) {
      if (!this.isXhsReady) {
        this.triggerNotifyPrintError(dataSource, data);
        return false;
      }
    }
    return true;
  }

  /**
   * add by tdd at  2020-11-27
   * 通用方法注入
   */;
  _proto._initMethods = function _initMethods() {
    var _this2 = this;
    Object.keys(COMMENDCONFIG).forEach(function (cell) {
      var method = COMMENDCONFIG[cell];
      _this2[cell] = function (arg) {
        var result = method === null || method === void 0 ? void 0 : method(arg);
        if (cell === 'printData') {
          var _ref2 = arg || {},
            _ref2$printConfig = _ref2.printConfig,
            printConfig = _ref2$printConfig === void 0 ? {} : _ref2$printConfig;
          var _printConfig$dataSour = printConfig.dataSource,
            dataSource = _printConfig$dataSour === void 0 ? CAINIAO : _printConfig$dataSour;
          if (!_this2.checkConnect(dataSource, result)) {
            try {
              var logParams = _extends({}, printConfig, {
                status: 'failed',
                process: 'FRONT_END',
                dataSource: dataSource,
                action: 'WebSocketDisconnect',
                request: ''
              });
              doLog(logParams);
            } catch (e) {
              console.log(e);
            }
            // return;
          }
          if (dataSource === PDD) {
            var _CnCommonPrint$pddPri, _CnCommonPrint$pddPri2, _CnCommonPrint$pddPri3;
            CnCommonPrint.pddPrintInstance && ((_CnCommonPrint$pddPri = CnCommonPrint.pddPrintInstance) === null || _CnCommonPrint$pddPri === void 0 ? void 0 : (_CnCommonPrint$pddPri2 = _CnCommonPrint$pddPri.input) === null || _CnCommonPrint$pddPri2 === void 0 ? void 0 : (_CnCommonPrint$pddPri3 = _CnCommonPrint$pddPri2.next) === null || _CnCommonPrint$pddPri3 === void 0 ? void 0 : _CnCommonPrint$pddPri3.call(_CnCommonPrint$pddPri2, JSON.stringify(result)));
          } else if (dataSource === JD) {
            var _CnCommonPrint$jdPrin;
            CnCommonPrint.jdPrintInstance && ((_CnCommonPrint$jdPrin = CnCommonPrint.jdPrintInstance.input) === null || _CnCommonPrint$jdPrin === void 0 ? void 0 : _CnCommonPrint$jdPrin.next(JSON.stringify(result)));
          } else if (dataSource === BYTE) {
            var _CnCommonPrint$bytePr;
            CnCommonPrint.bytePrintInstance && ((_CnCommonPrint$bytePr = CnCommonPrint.bytePrintInstance.input) === null || _CnCommonPrint$bytePr === void 0 ? void 0 : _CnCommonPrint$bytePr.next(JSON.stringify(result)));
          } else if (dataSource === KUAISHOU) {
            var _CnCommonPrint$kuaiSh;
            CnCommonPrint.kuaiShouPrintInstance && ((_CnCommonPrint$kuaiSh = CnCommonPrint.kuaiShouPrintInstance.input) === null || _CnCommonPrint$kuaiSh === void 0 ? void 0 : _CnCommonPrint$kuaiSh.next(JSON.stringify(result)));
          } else if (dataSource === VIP) {
            var _CnCommonPrint$vipPri;
            CnCommonPrint.vipPrintInstance && ((_CnCommonPrint$vipPri = CnCommonPrint.vipPrintInstance.input) === null || _CnCommonPrint$vipPri === void 0 ? void 0 : _CnCommonPrint$vipPri.next(JSON.stringify(result)));
          } else if (dataSource === HUAWEI) {
            var _CnCommonPrint$huaWei;
            CnCommonPrint.huaWeiPrintInstance && ((_CnCommonPrint$huaWei = CnCommonPrint.huaWeiPrintInstance.input) === null || _CnCommonPrint$huaWei === void 0 ? void 0 : _CnCommonPrint$huaWei.next(JSON.stringify(result)));
          } else if (dataSource === XHS) {
            var _CnCommonPrint$xhsPri;
            CnCommonPrint.xhsPrintInstance && ((_CnCommonPrint$xhsPri = CnCommonPrint.xhsPrintInstance.input) === null || _CnCommonPrint$xhsPri === void 0 ? void 0 : _CnCommonPrint$xhsPri.next(JSON.stringify(result)));
          } else if (EventManager.Instance.supposeCloud) {
            var _CnCommonPrint$cloudP;
            CnCommonPrint.cloudPrintInstance && ((_CnCommonPrint$cloudP = CnCommonPrint.cloudPrintInstance.input) === null || _CnCommonPrint$cloudP === void 0 ? void 0 : _CnCommonPrint$cloudP.next(JSON.stringify(result)));
          } else {
            var _CnCommonPrint$wetPri, _CnCommonPrint$wetPri2;
            CnCommonPrint.wetPrintInstance && ((_CnCommonPrint$wetPri = CnCommonPrint.wetPrintInstance.input) === null || _CnCommonPrint$wetPri === void 0 ? void 0 : _CnCommonPrint$wetPri.next((_CnCommonPrint$wetPri2 = CnCommonPrint.wetPrintInstance) === null || _CnCommonPrint$wetPri2 === void 0 ? void 0 : _CnCommonPrint$wetPri2.wetStringify(result)));
          }
          try {
            var _logParams = _extends({}, printConfig, {
              status: 'success',
              process: 'FRONT_END',
              dataSource: dataSource,
              action: 'sendPrintDataToWet',
              request: _this2.getSimProtocol(dataSource, result)
            });
            doLog(_logParams);
          } catch (e) {
            console.log(e);
          }
        } else {
          var _data2 = result.data,
            printer = result.printer;
          if (EventManager.Instance.supposeCloud) {
            CnCommonPrint.cloudPrintInstance && CnCommonPrint.cloudPrintInstance.input.next(JSON.stringify(_data2));
          } else {
            CnCommonPrint.wetPrintInstance && CnCommonPrint.wetPrintInstance.input.next(CnCommonPrint.wetPrintInstance.wetStringify(result));
          }
          if (CnCommonPrint.pddPrintInstance) {
            printer && (_data2.printer = printer);
            CnCommonPrint.pddPrintInstance.input.next(JSON.stringify(_data2));
          }
        }
      };
    });
    Object.keys(MessageCenter).forEach(function (cell) {
      var method = MessageCenter[cell];
      if (typeof method === 'function') {
        _this2[cell] = function () {
          for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
            arg[_key] = arguments[_key];
          }
          method.apply(_this2, arg);
        };
      }
    });
  }

  // 获取简化协议
  ;
  _proto.getSimProtocol = function getSimProtocol(dataSource, protocol) {
    var simpleProto = {
      taskID: ''
    };
    if (dataSource === CAINIAO) {
      var _data3 = protocol.data;
      var task = _data3.task;
      simpleProto.taskID = task.taskID;
    } else if (dataSource === JD) {
      var key = protocol.key;
      simpleProto.taskID = key;
    } else {
      var _task3 = protocol.task;
      simpleProto.taskID = _task3.taskID;
    }
    return simpleProto;
  }

  // 老版打印
  ;
  _proto.doPrint = function doPrint(data) {
    CnCommonPrint.wetPrintInstance && CnCommonPrint.wetPrintInstance.doPrint(data);
  }

  // 老版自定义协议打印
  ;
  _proto.customPrint = function customPrint(data) {
    CnCommonPrint.wetPrintInstance && CnCommonPrint.wetPrintInstance.printData(data);
  }

  // 获取打印协议
  ;
  _proto.getPrintAgreement = function getPrintAgreement(params) {
    return COMMENDCONFIG.printData(params);
  }

  /*
   * 打印日志上报
   * @printConfig {Object} 打印参数
   * */;
  _proto.printLog = function printLog(printConfig) {
    try {
      var logParams = _extends({
        process: 'FRONT_END',
        action: 'sendPrintDataToWet'
      }, printConfig);
      doLog(logParams);
    } catch (e) {
      // do nothing
    }
  }

  /*
   * 移除链接
   * */;
  _proto.unsubscribe = function unsubscribe() {
    try {
      this.unsubscribePdd && this.unsubscribePdd();
      this.unsubscribeWet && this.unsubscribeWet();
      this.unsubscribeByte && this.unsubscribeByte();
      this.unsubscribeJd && this.unsubscribeJd();
      this.unsubscribeCloud && this.unsubscribeCloud();
      this.unsubscribeKuaiShou && this.unsubscribeKuaiShou();
      this.unsubscribeVip && this.unsubscribeVip();
      this.unsubscribeHuaWei && this.unsubscribeHuaWei();
      this.unsubscribeXhs && this.unsubscribeXhs();
    } catch (e) {
      console.log(e);
    }
  };
  return CnCommonPrint;
}();
// wet打印实例
CnCommonPrint.wetPrintInstance = null;
// pdd打印实例
CnCommonPrint.pddPrintInstance = null;
// JD打印实例
CnCommonPrint.jdPrintInstance = null;
// 抖音打印实例
CnCommonPrint.bytePrintInstance = null;
// 云打印实例
CnCommonPrint.cloudPrintInstance = null;
// 快手打印实例
CnCommonPrint.kuaiShouPrintInstance = null;
// 唯品会打印实例
CnCommonPrint.vipPrintInstance = null;
// 华为商城打印实例
CnCommonPrint.huaWeiPrintInstance = null;
// 小红书打印实例
CnCommonPrint.xhsPrintInstance = null;
export { doLog };
export default CnCommonPrint;